// eslint-disable-next-line import/prefer-default-export
export const MARKETPLACE_PLATFORM = {
  tokopedia: {
    logo: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/tokopedia-logo.png',
    label: 'Tokopedia',
  },
  shopee: {
    logo: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/shopee-logo.png',
    label: 'Shopee',
  },
  lazada: {
    logo: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/lazada-logo.png',
    label: 'Lazada',
  },
  tiktokShop: {
    logo: 'https://storage.googleapis.com/komerce/komads-meta/tiktok.svg',
    label: 'TikTok Shop',
  },
  kompack: {
    logo: 'https://storage.googleapis.com/komerce/icon/Vector.svg',
    label: 'Kompack',
  },
}
